import { useContext, useState } from 'react';
import {
  Alert,
  Modal,
  StyleSheet,
  Text,
  TextInput,
  TouchableHighlight,
  TouchableOpacity,
  View
} from 'react-native';
import { SafeAreaView } from 'react-native-safe-area-context';
import AppConstants from '../AppConstants';
import { APIContext } from '../contexts/APIContext';
import { useStorage } from '../contexts/StorageContext';
import Throb from './Throb';

const ContentItemFeedback = (props) => {
  const [modalVisible, setModalVisible] = useState(false);
  const [feedbackText, setFeedbackText] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  
  const { sendFeedback } = useContext(APIContext);
  const { voyagerCode } = useStorage();

  const startFeedback = () => {
    setModalVisible(true);
    setFeedbackText('');
  };

  const submitFeedback = async () => {
    props.contentitem.feedbackText = feedbackText;
    if (!feedbackText.trim()) {
      Alert.alert('Please enter some feedback before submitting.');
      return;
    }

    setIsSubmitting(true);
    try {
      await sendFeedback(props.contentitem, feedbackText.trim(), voyagerCode);
      setModalVisible(false);
      setFeedbackText('');      
    } catch (error) {
      console.error('Error submitting feedback:', error);
      Alert.alert('Error', 'Failed to submit feedback. Please try again.');
      setFeedbackText(''); // Retain the feedback text
    } finally {
      setIsSubmitting(false);
    }
  };

  const cancelFeedback = () => {
    setModalVisible(false);
    setFeedbackText('');
  };

  if (props.contentitem.feedbackText) {
    return (
      <Text style={modalStyles.feedbackText}>{props.contentitem.feedbackText}</Text>
    );
  } else {
    return (
      <>
        <TouchableHighlight onPress={startFeedback} underlayColor="white">
          <View style={modalStyles.feedbackButton}>
            <Throb>
              <Text style={modalStyles.feedbackButtonText}>Write Something</Text>
            </Throb>
          </View>
        </TouchableHighlight>

        <Modal
          animationType="slide"
          transparent={true}
          visible={modalVisible}
          onRequestClose={cancelFeedback}
        >
          <View style={modalStyles.overlay}>
            <SafeAreaView style={modalStyles.container}>
              <View style={modalStyles.modalContent}>
                <Text style={modalStyles.title}>Share Your Thoughts</Text>
                
                <TextInput
                  style={modalStyles.textInput}
                  multiline={true}
                  numberOfLines={6}
                  value={feedbackText}
                  onChangeText={setFeedbackText}
                  textAlignVertical="top"
                />               

                <View style={modalStyles.buttonContainer}>
                  <TouchableOpacity 
                    style={[modalStyles.button, modalStyles.cancelButton]} 
                    onPress={cancelFeedback}
                    disabled={isSubmitting}
                  >
                    <Text style={modalStyles.cancelButtonText}>Cancel</Text>
                  </TouchableOpacity>
                  
                  <TouchableOpacity 
                    style={[modalStyles.button, modalStyles.submitButton]} 
                    onPress={submitFeedback}
                    disabled={isSubmitting || !feedbackText.trim()}
                  >
                    <Text style={modalStyles.submitButtonText}>
                      {isSubmitting ? 'Submitting...' : 'Submit'}
                    </Text>
                  </TouchableOpacity>
                </View>
              </View>
            </SafeAreaView>
          </View>
        </Modal>
      </>
    );
  }
};

const modalStyles = StyleSheet.create({
  feedbackButton: {
    backgroundColor: AppConstants.blueColor,
    justifyContent: 'center',
    flexDirection: 'row',
    paddingTop: 20,
    paddingBottom: 20,
    marginTop: 20,
  },

  feedbackButtonText: {
    color: 'white',
    fontWeight: 'bold',
    fontSize: 18    
  },

  feedbackText: {
    fontFamily: 'American Typewriter',
    fontSize: 18,
    textAlign: 'center',
    marginVertical: 5,
    color: AppConstants.deepBlue,
    marginTop: 20
  },

  overlay: {
    flex: 1,
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    justifyContent: 'center',
    alignItems: 'center',
    paddingHorizontal: 20, // Increased padding for better spacing
  },
  container: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%', // Ensure full width
  },
  modalContent: {
    backgroundColor: 'white',
    borderRadius: 10,
    padding: 20,
    width: '90%', // Use percentage for better responsiveness
    maxWidth: 500, // Increased max width
    minWidth: 300, // Ensure minimum width
    shadowColor: '#000',
    shadowOffset: {
      width: 0,
      height: 2,
    },
    shadowOpacity: 0.25,
    shadowRadius: 3.84,
    elevation: 5,
  },
  title: {
    fontSize: 18,
    fontWeight: 'bold',
    marginBottom: 15,
    textAlign: 'center',
    color: '#333',
  },
  textInput: {
    borderWidth: 1,
    borderColor: '#ddd',
    borderRadius: 5,
    padding: 10,
    fontSize: 16,
    minHeight: 120,
    marginBottom: 10,
  },
 
  buttonContainer: {
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  button: {
    paddingVertical: 12,
    paddingHorizontal: 20,
    borderRadius: 5,
    flex: 1,
    marginHorizontal: 5,
  },
  cancelButton: {
    backgroundColor: '#f0f0f0',
  },
  cancelButtonText: {
    color: '#333',
    textAlign: 'center',
    fontSize: 16,
  },
  submitButton: {
    backgroundColor: '#007AFF',
  },
  submitButtonText: {
    color: 'white',
    textAlign: 'center',
    fontSize: 16,
    fontWeight: 'bold',
  },
});

export default ContentItemFeedback;
